import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_FILE]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_FILE]: (state, item) => removeItem(state, item)
}
